import {FormComponent, KeyValue} from "./form-component";

export function hasOptionKey(formComponent: FormComponent, key: string): boolean {
    return getOptionByKey(formComponent, key, undefined) !== undefined;
}

export function hasValidatorKey(formComponent: FormComponent, key: string): boolean {
    return getValidatorByKey(formComponent, key, undefined) !== undefined;
}

export function setValidator(formComponent: FormComponent, key: string, value: any): void {
    initValidators(formComponent);
    console.log('set validator key:' + key+ ' and value:' + value);
    setKeyValue(formComponent.validators, key, value);
    console.log(formComponent.validators);
}

export function setValidatorForComponentId(formComponent: FormComponent, id: string, key: string, value: any) {
    if (formComponent.id === id) {
        setValidator(formComponent, key, value);
    } else {
        if (hasChildren(formComponent)) {
            formComponent.components.forEach(comp => {
                setValidatorForComponentId(comp, id, key, value);
            });
        }
    }
}

export function setOption(formComponent: FormComponent, key: string, value: any): void {
    initOptions(formComponent);
    setKeyValue(formComponent.options, key, value);
    console.log(formComponent.options);
}

export function setOptionForComponentId(formComponent: FormComponent, id: string, key: string, value: any) {
    if (formComponent.id === id) {
        setOption(formComponent, key, value);
    } else {
        if (hasChildren(formComponent)) {
            formComponent.components.forEach(comp => {
                setOptionForComponentId(comp, id, key, value);
            });
        }
    }
}

export function setOptionRecursively(formComponent: FormComponent, key: string, value: any) {
    setOption(formComponent, key, value);
    if (hasChildren(formComponent)) {
        formComponent.components.forEach(comp => {
            setOptionRecursively(comp, key, value);
        });
    }
}

export function removeOption(formComponent: FormComponent, key: string) {
    if (hasOptionKey(formComponent, key)) {
        setOption(formComponent, key, '');
    }
}

export function removeOptionRecursively(formComponent: FormComponent, key: string) {
    removeOption(formComponent, key);
    if (hasChildren(formComponent)) {
        formComponent.components.forEach(comp => {
            removeOptionRecursively(comp, key);
        });
    }
}

export function getOptionByKey(formComponent: FormComponent, key: string, defaultValue: any): any {
    if (hasOptions(formComponent)) {
        const found = getKeyValue(formComponent.options, key);
        if (found !== undefined) {
            return found.value;
        }
    }
    return defaultValue;
}

export function getValidatorByKey(formComponent: FormComponent, key: string, defaultValue: any): any {
    if (hasValidators(formComponent)) {
        const found = getKeyValue(formComponent.validators, key);
        if (found !== undefined) {
            return found.value;
        }
    }
    return defaultValue;
}

export function generateId(component: FormComponent) {
    return component.type +'_Random_' + Math.random().toString(36).substring(6);
}

export function isTrue(value: any): boolean {
    return value == 'true' || value === 'true' || value == true || value === true;
}

export function initOptions(component: FormComponent): void {
    if (!hasOptions(component)) {
        component.options = [];
    }
}
export function initValidators(component: FormComponent): void {
    if (!hasValidators(component)) {
        component.validators = [];
    }
}

export function hasOptions(component: FormComponent): boolean {
    return isArrayNotEmpty(component.options);
}
export function hasValidators(component: FormComponent): boolean {
    return isArrayNotEmpty(component.validators);
}
export function hasChildren(component: FormComponent): boolean {
    return isArrayNotEmpty(component.components);
}
export function isArrayNotEmpty(myArray: any): boolean {
    return myArray!==undefined && myArray.length > 0;
}

export function getKeys(obj: KeyValue[]): string[] {
    console.log('obj:' + obj);
    if (Array.isArray(obj)) {
        const keyValueArray : KeyValue[] = Array.from(obj);
        const keys : string[] = keyValueArray.map(keyValue => keyValue.key);
        console.log('keys:' + keys);
        return keys;
    }
    return Object.keys(obj);
}
export function getKeyValue(keyValueArray: KeyValue[], key: string): KeyValue {
    let found = undefined;
    if (isArrayNotEmpty(keyValueArray)) {
        keyValueArray.forEach(keyValue => {
            if (keyValue.key === key) {
                found = keyValue;
            }
        });
    }
    return found;
}
export function setKeyValue(keyValueArray: KeyValue[], key: string, value: any): void {
    console.log('empty:' + !isArrayNotEmpty(keyValueArray));
    let foundKeyValue = getKeyValue(keyValueArray, key);
    if (foundKeyValue !== undefined) {
        console.log('value found');
        foundKeyValue.value = value;
    } else {
        const keyValue = new KeyValue();
        keyValue.key = key;
        keyValue.value = value;
        keyValueArray.push(keyValue);
    }
}
export function resetOptionsForComponentId(formComponent: FormComponent, id: string) {
    if (formComponent.id === id) {
        formComponent.options = [];
    }
    if (hasChildren(formComponent)) {
        formComponent.components.forEach(comp => {
            resetOptionsForComponentId(comp, id);
        });
    }
}
export function resetValidatorsForComponentId(formComponent: FormComponent, id: string) {
    if (formComponent.id === id) {
        formComponent.validators = [];
    }
    if (hasChildren(formComponent)) {
        formComponent.components.forEach(comp => {
            resetOptionsForComponentId(comp, id);
        });
    }
}
